import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { apiUrl } from '@/lib/api'

const LINE_ICON = (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6">
    <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.627-.63h2.386c.349 0 .63.285.63.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.627-.63.349 0 .631.285.631.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" />
  </svg>
)

export function LoginPage() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const { isAuthenticated, isLoading } = useAuth()
  const error = params.get('error')

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true })
    }
  }, [isAuthenticated, navigate])

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-gray-500">กำลังโหลด...</div>
      </div>
    )
  }

  const errorMessages: Record<string, string> = {
    not_authorized: 'ไม่พบบัญชีครูในระบบ กรุณาติดต่อผู้ดูแล',
    invalid_state: 'เกิดข้อผิดพลาดในการเข้าสู่ระบบ กรุณาลองใหม่',
    missing_params: 'เกิดข้อผิดพลาดในการเข้าสู่ระบบ กรุณาลองใหม่',
    consent_required: 'กรุณายินยอมการเข้าถึงข้อมูล LINE',
    access_denied: 'การเข้าสู่ระบบถูกยกเลิก',
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-sm">
        {/* Logo & School Name */}
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-2xl bg-primary-600 text-3xl font-bold text-white">
            กด
          </div>
          <h1 className="text-2xl font-bold text-gray-900">ครูดรีม</h1>
          <p className="mt-1 text-sm text-gray-500">ระบบจัดการห้องเรียน</p>
          <p className="text-xs text-gray-400">โรงเรียนเมืองเลย</p>
        </div>

        {/* Error message */}
        {error && (
          <div className="mb-4 rounded-lg bg-red-50 p-3 text-center text-sm text-red-700">
            {errorMessages[error] || 'เกิดข้อผิดพลาด กรุณาลองใหม่'}
          </div>
        )}

        {/* LINE Login Button */}
        <a
          href="/api/auth/line"
          className="flex w-full items-center justify-center gap-3 rounded-lg bg-[#06C755] px-4 py-3 text-base font-semibold text-white transition-colors hover:bg-[#05b34c] active:bg-[#049a42]"
        >
          {LINE_ICON}
          เข้าสู่ระบบด้วย LINE
        </a>

        <p className="mt-6 text-center text-xs text-gray-400">
          สำหรับครูประจำชั้น ป.3/4 เท่านั้น
        </p>
      </div>
    </div>
  )
}
